import { css } from '@emotion/react';

import { SCROLL_UP } from '../../const';
import useTheme from '../../hooks/useTheme';
import publicPath from '../../utils/publicPath';

export default () => {
  const { screenSizes, typography, breakpoints, colors, heights } = useTheme();

  return {
    hero: ({ mobile, desktop }, scrollDirection, headerHeight, isRec) => {
      return css`
        display: grid;
        align-items: end;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        grid-template-rows: 70% 30%;
        align-items: center;
        background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0) 20%,
            rgba(1, 30, 65) ${isRec === 'true' ? '55%' : '75%'},
            rgba(1, 30, 65) 100%
          ),
          url(${mobile.src}) 75% 0 no-repeat;
        background-size: contain;
        height: 812px;
        margin-top: ${scrollDirection === SCROLL_UP
          ? 0
          : heights.mainNav.mobile};

        ${breakpoints.m} {
          grid-template-rows: 60% 40%;
          align-items: center;
          background: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 20%,
              rgba(1, 30, 65) 75%,
              rgba(1, 30, 65) 100%
            ),
            url(${desktop.src}) center 0 no-repeat;
          background-size: cover;
          margin-top: ${scrollDirection === SCROLL_UP ? 0 : headerHeight};

          &::before {
            top: 10vh;
            left: 0;
            width: 100%;
            height: 100vh;
            z-index: 1;
            outline: 0;

            ${breakpoints.l} {
              height: 700px;
              top: calc(100vh - 95vh);
            }
          }

          &::after {
            background: url(${publicPath(
                '/images/common/discover-football-watermark.svg'
              )})
              right center no-repeat;
          }
        }
      `;
    },
    textWrapper: hasLoaded => css`
      position: relative;
      z-index: 1;
      align-self: end;
      opacity: 0;
      transition: opacity 0.5s;
      width: 90vw;
      margin: 0 auto;
      margin: 0px auto calc(27vh);

      ${hasLoaded &&
      css`
        opacity: 1;
      `}

      &.fadeOut {
        opacity: 0.3;
      }

      ${breakpoints.m} {
        max-width: ${screenSizes.xl};
      }

      @media (min-device-width: 768px) and (max-device-width: 992px) {
        margin: 0 0 0 50px !important;
      }
    `,
    mainText: css`
      ${typography.headings[3].mobile};
      font-family: FS Dillon !important;
      font-style: normal;
      font-size: 37.32px;
      z-index: 2;
      position: relative;
      letter-spacing: 0.02em !important;
      color: ${colors.white};
      max-width: unset;
      transition: opacity 0.5s;
      text-align: center;
      margin: auto;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -5px;
        width: 70px;
        left: Calc(100% - 61%);

        ${breakpoints.m} {
          left: Calc(100% - 53%);
        }
      }

      ${breakpoints.m} {
        ${typography.headings[1].desktop};
        max-width: 100%;
        font-size: 37.32px;
        font-style: normal;
        font-weight: 700;
        line-height: 84px;
        text-align: left;
      }

      ${breakpoints.l} {
        font-weight: 700;
        font-size: 44.79px;
        line-height: 1.2;
        font-font-style: normal;
        text-align: center;
      }
    `,
    RedUnderLine: css`
      position: relative;
      display: inline-block;
      line-height: 1.2;

      &:after,
      &:before {
        content: '';
        position: absolute;
        left: 0;
        width: 100%;
        z-index: -1;
      }

      &:after {
        bottom: 8px;
        height: 6px;
        @media (min-device-width: 768px) and (max-device-width: 991px) {
          bottom: 5px;
        }
        background-color: ${colors.red_CB0A00};
      }

      &:before {
        bottom: 4px;
        height: 8px;
        @media (min-device-width: 768px) and (max-device-width: 991px) {
          bottom: 0px;
        }
        background-color: ${colors.red_FF0D00};
      }
    `,
    RedUnderLineStripe: css`
      position: relative;
      display: inline-block;
      line-height: 1.2;

      text-decoration: underline;
      text-decoration-color: ${colors.red_FF0D00};
      text-decoration-thickness: 0.5rem;
      text-decoration-skip-ink: none;
      text-underline-offset: -0.125rem;

      ::selection {
        text-decoration: underline;
        text-decoration-color: ${colors.red_FF0D00};
        text-decoration-thickness: 0.5rem;
        text-decoration-skip-ink: none;
        text-underline-offset: -0.125rem;
      }

      span {
        text-decoration: underline;
        text-decoration-color: ${colors.red_CB0A00};
        text-decoration-thickness: 0.25rem;
        text-decoration-skip-ink: none;
        text-underline-offset: -0.125rem;
      }
    `,
    cta: css`
      background-color:${colors.buttonRed};
      color: ${colors.white};
      text-transform: uppercase;
      border: 3px solid transparent;
      font-size: 1rem;
      height: 2.75rem;
      cursor: pointer;
      max-width: 300px;
      margin: 0 auto; 
      margin-top: 1.5rem;

      ${breakpoints.m} {
        margin: 0 auto; 
        margin-top: 1.5rem; 
      }
      ${breakpoints.mm_m_l} {
        font-size: 0.875rem;
      }
      ${breakpoints.mm_s_m} {
        font-size: 0.875rem;
      }
      ${breakpoints.mm_xs_s} {
        font-size: 0.875rem;
      }
      ${breakpoints.mm_xxs_xs} {
        font-size: 0.875rem;
      }
        &:focus {
          outline: 0;    
          border: 2px solid ${colors.white};
          border-radius: 0.25rem;
        }
        &:hover{
          border: 2px solid transparent;
          border-radius: 0rem;
        }
        &:focus-visible{
          background-color: ${colors.skip_yellow};
          color: ${colors.border_black};
          text-decoration: underline;
          text-decoration-color: ${colors.border_black};
          outline: none;
          border: 2px solid ${colors.border_black};
        }
      }
    `,

    sectionHero: (
      { mobile, desktop },
      scrollDirection,
      headerHeight,
      isRec
    ) => {
      return css`
        padding: 112px 0;
        margin-top: 110px;
        min-height: 409px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 30rem;
        background: #020f31
          url(${publicPath('/images/desktop/recommendations/hero/hero-bg.jpg')})
          no-repeat center;
        background-size: cover;
        color: #fff;
        text-align: center;
        @media (max-width: 62rem) {
          justify-content: flex-end;
          height: auto;
          min-height: 30rem;
          padding-bottom: 0;
          .container {
            height: auto;
            width: 100%;
            text-align: center;
            h1 {
              text-align: center;
            }
          }
        }

        ::before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 1;
          background: url(${publicPath(
                '/images/desktop/recommendations/hero/hero-left.png'
              )})
              no-repeat left -14.75rem bottom,
            url(${publicPath(
                '/images/desktop/recommendations/hero/hero-right.webp'
              )})
              no-repeat right 0rem bottom -5.75rem;

          @media (max-width: 62rem) {
            background: url(${publicPath(
                '/images/desktop/recommendations/hero/hero-right.png'
              )})
              no-repeat left 45% top -1.5rem;
            background-size: 40rem;
          }
        }
        ::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 2;
          height: 12.5rem;
          background-image: linear-gradient(
            180deg,
            rgba(2, 15, 49, 0) 0%,
            rgba(2, 15, 49, 0.8) 70%,
            #020f31 100%
          );

          @media (max-width: 62rem) {
            display: none;
          }
        }
      `;
    },
    heroContent: css`
      position: relative;
      z-index: 3;
      padding: 2rem 24rem;
      width: 100%;
      @media (max-width: 74rem) {
        padding: 2rem 20rem;
      }
      @media (max-width: 62rem) {
        padding: 2rem;
        background-image: linear-gradient(
          180deg,
          rgba(2, 15, 49, 0) 0%,
          rgba(2, 15, 49, 0.8) 20%,
          #020f31 50%
        );
      }
    `,
    bannerDescription: css`
      & > div {
        margin: 0;
      }
    `,
  };
};
